// React Query обвивките на „Склад по продукт". Записът опреснява и прегледите
// на разнасянето (`["inventory", "report-posting-preview", …]`) — белегът
// „склад на продукта" и предизборът идват от тях. Работният лист НЕ се
// преинициализира от това (`ReportPostingDetail` го пуска веднъж), така че
// ръчно избраното по другите продукти остава.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteProductWarehouse,
  getProductWarehouses,
  setProductWarehouse,
} from "../api/inventoryProductWarehouses";

const PRODUCT_WAREHOUSES_KEY = ["inventory", "product-warehouses"] as const;

export const useProductWarehouses = () =>
  useQuery({
    queryKey: PRODUCT_WAREHOUSES_KEY,
    queryFn: getProductWarehouses,
    // BE без endpoint-а (404) → празен списък, без повторни опити
    retry: false,
  });

const useInvalidateProductWarehouses = () => {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: PRODUCT_WAREHOUSES_KEY });
    qc.invalidateQueries({ queryKey: ["inventory", "report-posting-preview"] });
  };
};

export const useSetProductWarehouse = () => {
  const invalidate = useInvalidateProductWarehouses();
  return useMutation({
    mutationFn: ({ productId, warehouseId }: { productId: number; warehouseId: number }) =>
      setProductWarehouse(productId, warehouseId),
    onSuccess: invalidate,
  });
};

export const useDeleteProductWarehouse = () => {
  const invalidate = useInvalidateProductWarehouses();
  return useMutation({
    mutationFn: (productId: number) => deleteProductWarehouse(productId),
    onSuccess: invalidate,
  });
};
